import {get, merge, xor, cookies, omit, isMatch, Base64, handleError, createReducer} from 'helpers';
import {appSettings} from '.';

export const settings = createReducer(initialState(), {

  APP_LAUNCH: state => omit(state, 'today.date'),
  APP_HOT_LAUNCH: state => omit(state, 'today.date'),

  UI_SETTING_UPDATE: (state, { name, value }) => {
    return {
      ...state,
      [name]: value
    }
  },

  UI_SETTING: (state, { module, key, value }) => {
    if (!key) {
      throw 'Key not specified';
    }
    if (typeof value == 'function') {
      const path = [module, key].filter(Boolean).join('.');
      const currentValue = get(state, path);
      value = value(currentValue);
    }
    if (module) {
      return {
        ...state,
        [module]: {
          ...state[module],
          [key]: value,
        }
      }
    }
    return  {
      ...state,
      [key]: value,
    }
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const settings = {};
    if (action.settings?.webSettings) {
      try {
        const text = Base64.decode(action.settings.webSettings).replace(/[^}]+$/, '');
        merge(settings, JSON.parse(text));
      } catch (error) {
        handleError(error, { func: settings, filename: 'settings/reducer.js', extra: action.settings.webSettings });
      }
    }
    merge(settings, appSettings({ settings: action.settings }));
    merge(settings, {gptConnects: action.gptConnects});
    return isMatch(state, settings) ? state : { ...state, ...settings };
  },

  UI_SETTING_SET_GPT_CONNECTS: (state, {value}) => ({
    ...state,
    gptConnects: value
  }),

  TODAY_TOGGLE_NOTE_CATEGORY: (state, { id }) => ({
    ...state,
    today: {
      ...state.today,
      notesCategoriesBlacklist: xor(state.today.notesCategoriesBlacklist, [ id ]),
    }
  }),

  UI_TODAY_RESET: state => {
    if (state.today.date) {
      return {
        ...state,
        today: omit(state.today, 'date')
      }
    }
    return state;
  },

  UI_PRINT:       (state, {target}) => ({ ...state, printTarget: target }),

  UI_PRINT_RESET: (state, {target}) => ({ ...state, printTarget: target }),

  TESTING_DELETE_ALL: initialState

});

function initialState() {
  return {
    announcements: {},
    defaults: {},
    fullscreen: false,
    gptConnects: 0,
    primaryNavigationCollapsed: false,
    printTarget: 'main',
    theme: cookies.get('theme') || (isDarkMode() ? 'dark' : 'light'),
    webVersion: '',
    today: {
      period: 'three-days',
      group: 'time',
    },
    activities: {
      group: 'date',
      status: 'Not Started',
    },
    routines: {
      group: 'time',
      status: 'Not Started',
    },
    habits: {
      group: 'time',
      status: 'Not Started',
    },
  }
}

function isDarkMode() {
  if (typeof window == 'object') {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
}
